<script>
  import { _ } from "svelte-i18n";

  export let maincolor = "#2563eb";
  export let darkercolor = "#1e40af";

  export let id;
  export let question = "";
  export let willingness = -1;
  export let willingnessIsValid = true;
  export let onWillingnessChange = () => {};

  function handleChange() {
    onWillingnessChange(id, willingness);
  }

  $: if (willingness != -1 && willingness >= 1 && willingness <= 10) {
    willingnessIsValid = true;
  }
</script>

<div>
  <p class="mt-45px text-20px">{question}</p>

  {#if willingnessIsValid == false}
    <div class="mb-5px italic text-red-600 text-16px">
      {$_("CHOOSE_NUMBER")}
    </div>
  {/if}

  <div class="willingness mt-20px <sm:(grid grid-rows-5 gap-2)">
    <div class="<sm:(row-span-5) my-16px inline-block">
      <input
        type="radio"
        bind:group={willingness}
        on:change={handleChange}
        name={`willingness${id}`}
        value="1"
        id={`rec_1${id}`} />
      <label class="numberCircle" for={`rec_1${id}`}>&nbsp;1&nbsp;</label>
      <input
        type="radio"
        bind:group={willingness}
        on:change={handleChange}
        name={`willingness${id}`}
        value="2"
        id={`rec_2${id}`} />
      <label class="numberCircle" for={`rec_2${id}`}>&nbsp;2&nbsp;</label>
      <input
        type="radio"
        bind:group={willingness}
        on:change={handleChange}
        name={`willingness${id}`}
        value="3"
        id={`rec_3${id}`} />
      <label class="numberCircle" for={`rec_3${id}`}>&nbsp;3&nbsp;</label>
      <input
        type="radio"
        bind:group={willingness}
        on:change={handleChange}
        name={`willingness${id}`}
        value="4"
        id={`rec_4${id}`} />
      <label class="numberCircle" for={`rec_4${id}`}>&nbsp;4&nbsp;</label>
      <input
        type="radio"
        bind:group={willingness}
        on:change={handleChange}
        name={`willingness${id}`}
        value="5"
        id={`rec_5${id}`} />
      <label class="numberCircle" for={`rec_5${id}`}>&nbsp;5&nbsp;</label>
    </div>

    <div class="<sm:(row-span-5) my-16px inline-block">
      <input
        type="radio"
        bind:group={willingness}
        on:change={handleChange}
        name={`willingness${id}`}
        value="6"
        id={`rec_6${id}`} />
      <label class="numberCircle" for={`rec_6${id}`}>&nbsp;6&nbsp;</label>
      <input
        type="radio"
        bind:group={willingness}
        on:change={handleChange}
        name={`willingness${id}`}
        value="7"
        id={`rec_7${id}`} />
      <label class="numberCircle" for={`rec_7${id}`}>&nbsp;7&nbsp;</label>
      <input
        type="radio"
        bind:group={willingness}
        on:change={handleChange}
        name={`willingness${id}`}
        value="8"
        id={`rec_8${id}`} />
      <label class="numberCircle" for={`rec_8${id}`}>&nbsp;8&nbsp;</label>
      <input
        type="radio"
        bind:group={willingness}
        on:change={handleChange}
        name={`willingness${id}`}
        value="9"
        id={`rec_9${id}`} />
      <label class="numberCircle" for={`rec_9${id}`}>&nbsp;9&nbsp;</label>
      <input
        type="radio"
        bind:group={willingness}
        on:change={handleChange}
        name={`willingness${id}`}
        value="10"
        id={`rec_10${id}`} />
      <label class="numberCircle" for={`rec_10${id}`}>10</label>
    </div>
  </div>
  <div
    class="flex flex-row justify-between w-510px mt-4px italic
              <sm:hidden">
    <div class="text-16px">{$_("NOT_AT_ALL")}</div>
    <div class="text-16px">{$_("EXTREMELY")}</div>
  </div>
</div>

<style windi:preflights:global windi:safelist:global>
  .numberCircle {
    border: 1px solid #666;
    color: #666;

    @apply bg-transparent font-bold w-26px h-26px p-8px text-center text-24px rounded-15px mb-8px <sm:text-20px;
    /* <md:(w-20px h-24px !text-20px mx-2px) <sm:(flex items-center text-20px mx-1px !border-1) */
  }

  .willingness input {
    @apply hidden;
  }

  .willingness label {
    @apply relative cursor-pointer text-gray-600;
  }

  .willingness label:hover {
    @apply bg-$maincolor text-white border-$maincolor;
  }

  .willingness input:checked + label {
    @apply bg-$maincolor text-white border-$maincolor;
  }
</style>
